import { Box, Divider, Typography } from '@mui/material';
import { theme } from '@theguarantors/tg-package-material-ui';

type Props = {
  label: string;
  open: boolean;
};

const SideMenuDividerV2 = ({ label, open }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        height: '22px',
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: '12px',
        marginTop: '12px',
        marginBottom: '2px',
        marginX: '12px',
        gap: '12px',
      }}
    >
      {open && (
        <Typography
          sx={{
            color: theme.palette.neutralGrey[400],
            fontSize: '14px',
            whiteSpace: 'nowrap',
            fontWeight: 600,
          }}
        >
          {label.toUpperCase()}
        </Typography>
      )}
      <Divider
        sx={{
          flex: 1,
          borderColor: theme.palette.neutralGrey[200],
        }}
      />
    </Box>
  );
};

export default SideMenuDividerV2;
